import { Divider, Grid, Typography, useTheme } from "@mui/material";
import { differenceInCalendarDays } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./interfaces";
import {
  AddedOnBlock,
  CardWrapper,
  DateContainer,
  DaysLeftBlock,
  ExpirySection,
  StatsBlock,
  StatsContainer,
  StatusBlock,
  StyledCard,
  TitleAndExpiryDateBlock,
} from "./styles";
import { CustomDate } from "../../../models/custom-date/custom-date";
import { listOfMonths } from "../../../utils/time-utils";

const MySurveysCard = ({ item }: Props) => {
  const tRP = "components.employee_survey_card";
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <CardWrapper>
        <StyledCard>
          <AddedOnBlock>
            {`${t(`${tRP}.started_at`)}`}
            <DateContainer>
              {item.employeeSurveyConfiguration?.startedAt && (
                <>
                  <Typography>{item.employeeSurveyConfiguration.startedAt.day}</Typography>
                  <Grid>
                    <Typography variant="body2">
                      {t(`months.${listOfMonths[item.employeeSurveyConfiguration.startedAt.month - 1]}`)}
                    </Typography>
                    <Typography variant="body2">{item.employeeSurveyConfiguration.startedAt.year}</Typography>
                  </Grid>
                </>
              )}
            </DateContainer>
          </AddedOnBlock>

          <Divider
            orientation="vertical"
            flexItem
            style={{ alignSelf: "center", height: "100px" }}
          />

          <TitleAndExpiryDateBlock>
            <Typography variant="h5">{item.employeeSurveyConfiguration?.name}</Typography>
            <ExpirySection>
              {item.employeeSurveyConfiguration?.expiryDate ? (
                <>
                  <Typography>{`${t(`${tRP}.expires_on`)}`}</Typography>
                  <DateContainer>
                    <Typography>{item.employeeSurveyConfiguration.expiryDate.day}</Typography>
                    <Grid>
                      <Typography variant="body2">
                        {t(`months.${listOfMonths[item.employeeSurveyConfiguration.expiryDate.month - 1]}`)}
                      </Typography>
                      <Typography variant="body2">{item.employeeSurveyConfiguration.expiryDate.year}</Typography>
                    </Grid>
                  </DateContainer>
                </>
              ) : (
                <Typography color={theme.palette.secondary.light}>
                  <i>{`${t(`${tRP}.no_expiry_date`)}`}</i>
                </Typography>
              )}
            </ExpirySection>
          </TitleAndExpiryDateBlock>
          {item.employeeSurveyConfiguration?.expiryDate && (
            <DaysLeftBlock>
              <Typography variant="h5">
                {`${differenceInCalendarDays(
                  CustomDate.ToDate(item.employeeSurveyConfiguration.expiryDate)!,
                  new Date()
                )} ${t(`${tRP}.days_left`)}`}
              </Typography>
            </DaysLeftBlock>
          )}
          <StatsBlock>
            <StatsContainer>
              <Typography variant="body2">{`${t(`${tRP}.answered_questions`)}`}</Typography>
              <Typography>
                {`${
                  item.surveyItems.filter(
                    (surveyItem) =>
                      surveyItem.polarAnswer !== null ||
                      surveyItem.predefinedAnswer !== null ||
                      surveyItem.ranking !== null ||
                      surveyItem.textAnswer !== null
                  ).length
                } / 
                  ${item.employeeSurveyConfiguration?.surveyItems.length}  
                `}
              </Typography>
            </StatsContainer>
          </StatsBlock>
          <StatusBlock statusId={item.status?.id ?? ""}>
            <Typography variant="h5">{item.status?.name ?? `${t(`${tRP}.undefined_status`)}`}</Typography>
          </StatusBlock>
        </StyledCard>
      </CardWrapper>
    </>
  );
};

export default MySurveysCard;
